import React from 'react'
import NextImage from 'next/image'
import { Button } from '@components/ui/Button'
import styles from './styles.module.scss'
import { useCalendly } from './hooks'

export type BookCustomerServiceProps = {
  title: string
  variant?: 'primary' | 'secondary'
  className?: string
  utmSource?: string
  onButtonClick?: () => void
}

function BookCustomerService({
  title,
  variant = 'secondary',
  className = '',
  children,
  onButtonClick,
  utmSource
}: React.PropsWithChildren<BookCustomerServiceProps>) {
  const Calendly = useCalendly()
  return (
    <div className={`${styles.bookCustomerService__card} ${className}`}>
      <div className={styles.bookCustomerService__contentContainer}>
        <div className={styles.bookCustomerService__imageContainer}>
          <NextImage
            width="393"
            height="633"
            src="/static/images/michelle.jpg"
            alt="Customer service"
          />
        </div>
        <div className={styles.bookCustomerService__content}>
          <h3 className={styles.bookCustomerService__title}>{title}</h3>
          {children}
        </div>
      </div>
      <div className={styles.bookCustomerService__buttonContainer}>
        <Button
          onClick={() => {
            if (Calendly) {
              Calendly.showPopupWidget(
                `https://calendly.com/spoke/spoke-tune-up${
                  utmSource
                    ? `?utm_medium=website&utm_source=${utmSource}&utm_campaign=video_call`
                    : ''
                }`
              )
            }
            if (onButtonClick) {
              onButtonClick()
            }
          }}
          classes={styles.bookCustomerService__button}
          size="small"
          variant={variant}
          disabled={!Calendly}
          fullWidth="always"
        >
          Book now
        </Button>
      </div>
    </div>
  )
}

export default BookCustomerService
